/**
 * Created by lihanying on 2017/6/29.
 */
import {
  GETCLUBMEMBERLIST, GETCLUBLEVEL, GETCLUBWALLETINFO, GETCLUBWALLETRECORD,
  GETCLUBBOUGHT, GETCLUBPAYMENTTYPE, GETCLUBDIAMOND, GETCLUBDIAMONDRECORD, GETFOOTPRINTRECORD,
  GETRECORDDETAIL
} from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBMEMBERLIST:
      return Object.assign({}, state, { clubMemberList: action.payload })
    case GETCLUBLEVEL:
      return Object.assign({}, state, { clubLevel: action.payload })
    case GETCLUBWALLETINFO:
      return Object.assign({}, state, { clubWallet: action.payload })
    case GETCLUBWALLETRECORD:
      return Object.assign({}, state, { clubWalletRecord: action.payload })
    case GETCLUBBOUGHT:
      return Object.assign({}, state, { clubBought: action.payload })
    case GETCLUBPAYMENTTYPE:
      return Object.assign({}, state, { paymentType: action.payload })
    case GETCLUBDIAMOND:
      return Object.assign({}, state, { diamond: action.payload })
    case GETCLUBDIAMONDRECORD:
      return Object.assign({}, state, { diamondRecord: action.payload })
    case GETFOOTPRINTRECORD:
      return Object.assign({}, state, { footprintRecord: action.payload })
    case GETRECORDDETAIL:
      return Object.assign({}, state, { recordDetail: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/reduce.js